<template>
  <div :id="id" class="carousel slide" data-ride="carousel">
    <slot>
      <div class="carousel-inner">
        <div v-for="item in itemList" class="item">
          <a href="#" @click.prevent="$emit('linkEvent', item)">
            <img :src="item.image" :alt="item.desc" class="img-responsive hidden-xs w-100">
            <img :src="item.image_small" :alt="item.desc" class="img-responsive hidden-lg hidden-md hidden-sm w-100">
          </a>
        </div>
      </div>
    </slot>

    <!-- Left and right controls -->
    <a v-show="showControl" href="#" class="carousel-control carousel-control-prev" @click.prevent="prev()">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a v-show="showControl" href="#" class="carousel-control carousel-control-next" @click.prevent="next()">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>

    <!-- Indicators -->
    <ol v-show="showIndicator" class="carousel-indicators">
      <li v-for="count in totalSlide" :data-target="`#${id}`" :data-slide-to="count - 1" class="indicator"></li>
    </ol>
  </div>
</template>

<script>
  import 'jquery-touchswipe'

  export default {
    name: 'carousel',
    props: {
      id: {
        type: String,
        default () {
          return 'carousel'
        }
      },
      itemList: {
        type: Array,
        default () {
          return []
        }
      },
      index: {
        type: Number,
        default () {
          return 0
        }
      },
      options: {
        type: Object,
        default () {
          return {
            interval: 5000,
            keyboard: true,
            pause: true,
            ride: false,
            wrap: true
          }
        }
      },
      showControl: {
        type: Boolean,
        default () {
          return true
        }
      },
      showIndicator: {
        type: Boolean,
        default () {
          return true
        }
      }
    },
    data () {
      return {
        totalSlide: 0
      }
    },
    methods: {
      init () {
        const el = $(this.$el)

        // get Slide Count
        const itemLen = this.itemList.length
        this.totalSlide = itemLen > 0 ? itemLen : el.find('.item').length

        // init Carousel
        el.carousel(this.options)

        this.$nextTick(() => {
          this.addSwipeEvent()
          this.setActiveClass(this.index)
        })
      },
      prev () {
        $(this.$el).carousel('prev')
      },
      next () {
        $(this.$el).carousel('next')
      },
      addSwipeEvent () {
        $(this.$el).swipe({
          swipe: (event, direction, distance, duration, fingerCount, fingerData) => {
            if (direction === 'left') {
              this.next()
            }
            if (direction === 'right') {
              this.prev()
            }
          },
          allowPageScroll: 'vertical'
        })
      },
      setActiveClass (index = 0) {
        if (index >= this.itemList.length) {
          index = 0
        }

        const el = $(this.$el)
        const indicator = el.find('.indicator')[index]
        const item = el.find('.item')[index]

        $(indicator).addClass('active')
        $(item).addClass('active')
      }
    },
    mounted () {
      this.init()
    },
    beforeDestroy () {
      // remove Event
      $(this.$el).off('slid.bs.carousel')
    }
  }
</script>

<style lang="scss" scoped>
  .carousel {
    .carousel-indicators {
      bottom: -24px;
      margin-top: 0;
      margin-bottom: 0;

      li {
        width: 12px;
        height: 12px;
        margin: 0 6px;
        background-color: $hzc-gray-02;

        &.active {
          width: 25px;
          border-radius: 6px;
          background-color: $light-purple;
        }
      }

      @media (max-width: 767px) {
        bottom: -24px;
      }
    }

    .carousel-inner {
      border-radius: 4px;

      .item {
        max-height: 100%;
        width: 100%;

        img {
          max-height: 100%;
        }
      }

      @media (max-width: 767px) {
        border-radius: 0;
      }
    }

    .carousel-control {
      position: absolute;
      top: calc(50% - 24px);
      left: initial;
      width: 48px;
      height: 48px;
      background-color: rgba(0, 0, 0, 0.3);
      background-image: none;
      border-radius: 24px;
      text-align: center;

      &:focus {
        background-color: rgba(0, 0, 0, 0.3);
      }

      &-prev {
        left: 24px;
      }

      &-next {
        right: 24px;
      }

      .carousel-control-prev-icon,
      .carousel-control-next-icon {
        position: absolute;
        top: 14px;
        left: 14px;
        content: "";
        width: 20px;
        height: 20px;
        background-size: 20px 20px;
      }

      .carousel-control-prev-icon {
        background: url('~@/assets/svg/ic-arrow-left-white.svg');
      }

      .carousel-control-next-icon {
        background: url('~@/assets/svg/ic-arrow-right-white.svg');
      }

      @media (max-width: 767px) {
        top: calc(50% - 12px);
        height: 24px;
        width: 24px;
        border-radius: 12px;

        &-prev {
          left: 16px;
        }

        &-next {
          right: 16px;
        }

        .carousel-control-prev-icon,
        .carousel-control-next-icon {
          top: 4px;
          left: 4px;
          width: 16px;
          height: 16px;
          background-size: 16px 16px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue